import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { fetchHeroDiscoveriesIfNeeded, useHeroDiscoveries, } from './discoveries';
import { MINUTE_MS } from '../../time';
import { languagePlainSelector } from '../../selectors';
var useHeroDiscoveriesWithAutoFetching = function (buildNumber) {
    var heroDiscoveriesData = useHeroDiscoveries(buildNumber);
    var language = useSelector(languagePlainSelector);
    var dispatch = useDispatch();
    useEffect(function () {
        dispatch(fetchHeroDiscoveriesIfNeeded(buildNumber)).catch(function () { });
    }, [language, buildNumber, dispatch]);
    useEffect(function () {
        var interval = setInterval(function () {
            dispatch(fetchHeroDiscoveriesIfNeeded(buildNumber)).catch(function () { });
        }, 2 * MINUTE_MS);
        return function () {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [buildNumber, dispatch]);
    return heroDiscoveriesData;
};
export default useHeroDiscoveriesWithAutoFetching;
